import * as React from 'react'
import { connect } from 'react-redux'
import StatusActions from '../modules/status/status-actions'
import './message.css'



class Message extends React.Component<any, any>{

    onClick(){
        this.props.hideMessage();
        if(this.props.message.callback){
            this.props.message.callback()
        }
    }


    getBodyHTML(){
        return {
            __html: this.props.message.body
        }
    }

    

    render() {
        const message = this.props.message
        if(message){
            return (
                <div className="message">
                    <div className="modal fade show">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                { message.title &&
                                    <div className="modal-header">
                                        <h3 className="modal-title">{ message.title }</h3>
                                    </div>
                                }
                                <div className="modal-body">
                                    { message.body }
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" onClick={ this.onClick.bind(this) }>Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }else{
            return null;
        }
    }

}



const mapStateToProps = state => {
    return {
        message: state.status.message
    }
}


const mapDispatchToProps = dispatch => {
    return {
        hideMessage: () => dispatch( StatusActions.hideMessage() )
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Message)




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/message.tsx